import {
  CloseIcon,
  IconButton,
  KvdIcon,
  mq,
  theme,
  Title,
} from '@kvdbil/components';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const Container = styled.header`
  min-height: 2.25rem;
  background-color: ${theme.colors.background.gray};
  display: flex;
  align-items: center;
  padding: 0.75rem;
  border-bottom: 1px solid ${theme.colors.grayscaleToned.light3};

  ${mq(null, 'tablet')} {
    padding: 1rem;
  }

  svg {
    font-size: 1.5rem;
  }

  svg:first-child {
    margin-right: 0.5rem;
  }
`;

const CloseIconContainer = styled.div`
  margin-left: auto;
`;

interface Props {
  title?: string;
  icon?: ReactNode;
  onClose?: () => void;
}

const MainHeader = ({ icon, title, onClose }: Props) => {
  const { t } = useTranslation();
  return (
    <Container>
      {icon ?? <KvdIcon />}
      <Title>{title ?? t('Image Upload')}</Title>
      <CloseIconContainer>
        {onClose && (
          <IconButton
            isDisabled={false}
            isActive
            color="neutral"
            onClick={onClose}
          >
            <CloseIcon />
          </IconButton>
        )}
      </CloseIconContainer>
    </Container>
  );
};

export default MainHeader;
